<!-- START CONTENT -->
<section id="main-content" class="sidebar_shift">
  <section class="wrapper main-wrapper row">
    <div class="row">
      <div class="col-sm-4">
        <request-list-filter (onFilter)="onFilter($event)"></request-list-filter>
      </div>

      <div class="col-sm-8">
        <!-- START SEARCH RESULTS -->
        <div class="col-xs-12">
          <section class="box ">
            <header class="panel_header">
              <h2 class="title pull-left">Search results</h2>
              <div class="actions panel_actions pull-right">
                <a class="box_toggle fa fa-chevron-down"></a>
                <a class="box_setting fa fa-cog" data-toggle="modal" href="tables-basic.html#section-settings"></a>
              </div>
            </header>
            <div class="content-body">
              <div class="row">
                <div class="col-xs-12">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Reference</th>
                        <th>Date</th>
                        <!--<th>Test</th>-->
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let testRequest of TestRequests">
                        <td class="col-lg-3">
                          {{testRequest.ForeName}} {{testRequest.Surname}}
                        </td>
                        <td class="col-lg-1">
                          {{testRequest.Reference}}
                        </td>
                        <td class="col-lg-2">
                          {{testRequest.SampleDate|date:'dd/MM/yyyy HH:mm'}}
                        </td>
                        <!--<td class="col-lg-4">
                          <span *ngFor="let test of testRequest.Tests; let i = index"><label>{{test.TestCode}}</label><span *ngIf="i < testRequest.Tests.length - 1"> | </span></span>
                        </td>-->
                        <td class="col-lg-1">
                          <input type="button" value="Details" (click)="viewDetails(testRequest)" class="btn-link btn-primary" />
                        </td>
                        <!--<td class="col-lg-1">
                          <input type="button" value="Delete" (click)="delete(testRequest)" class="btn-danger" />
                        </td>-->
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>


            </div>
          </section>

        </div>
        <!-- END SEARCH RESULTS -->
      </div>
    </div>
  </section>
</section>
